import { gql } from 'src/generated/gql';

export const GET_DENIAL_REASONS = gql(`
  query GetDenialReasons {
    staff_idVerificationDenialReasons
  }
`);
